import {Injectable} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SelectMastercupSearchComponent} from "./select-mastercup-search.component";
import {defer, Observable} from "rxjs";
import {MastercupDto, SubDistrictDto} from "../../../../generated-model/model";

@Injectable({providedIn: "root"})
export class SelectMastercupSearchService {

  constructor(private modalService: NgbModal) {
  }

  open(subDistrict?: SubDistrictDto): Observable<MastercupDto> {

    const modalRef = this.modalService.open(SelectMastercupSearchComponent, {
      // fullscreen: true,
      size: "xl",
      windowClass: 'custom-modal-content',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.subDistrict = subDistrict;
    return defer(() => modalRef.result);
  }
}
